import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAlert } from "../context/AlertContext";

//Componentes
import Input from "../components/Input";
import Loading from "../animations/Loading"

//Estilos
import "../css/Register.css"; 

function Register({ setIsLoggedIn, setTipoSession }) {
    const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Nuevo estado para la confirmación
    const [formData, setData] = useState({ 
        nombre: "", 
        apellidoP: "", 
        apellidoM: "", 
        correo: "", 
        contraseña: "", 
        confirmarContraseña: ""
    });
    
    //Animación
    const [loading, setLoading] = useState(false);
    const handleNavigateToLogin = () => {
        setLoading(true);
        setTimeout(() => {
            navigate("/login");
        }, 1000);
    };
    
    if (loading) {
        return <Loading />;
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...formData, [name]: value });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    };

    const validate = () => {
        const newErrors = {};
        
        for (const key in formData) {
            if (!formData[key].trim()) {
                newErrors[key] = `Este campo es obligatorio`;
            }
        }

        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (formData.correo && !emailRegex.test(formData.correo)) {
            newErrors.correo = "El correo no es válido";
        }

        const passwordRegex = /^(?=.*[!@#$%^&*])(?=.{6,})/;
        if (formData.contraseña && !passwordRegex.test(formData.contraseña)) {
            newErrors.contraseña = "La contraseña debe tener al menos 6 caracteres y al menos un carácter especial";
        }

        if (formData.contraseña !== formData.confirmarContraseña) {
            newErrors.confirmarContraseña = "Las contraseñas no coinciden";
        }

        return newErrors;
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
    
        try {
            const response = await axios.post(URL_API+"auth/register", {
                nombre: formData.nombre, 
                apellidoP: formData.apellidoP, 
                apellidoM: formData.apellidoM, 
                correo: formData.correo, 
                contraseña: formData.contraseña,
            });
    
            if (response.data.success) {
                localStorage.setItem("userSession", response.data.user);
                localStorage.setItem("tipoSession", response.data.tipo);
                localStorage.setItem("tokenSession", response.data.token);

                const userSession = localStorage.getItem("userSession");
                const tipoSession = localStorage.getItem("tipoSession");
                const tokenSession = localStorage.getItem("tokenSession");
                
                setLoading(true);
                showAlert(response.data.message, "success");
                setTimeout(() => {
                    if (userSession && tokenSession) {
                        setIsLoggedIn(true);
                        setTipoSession(tipoSession);
                    }
                }, 1000);
            } else {
                showAlert(response.data.message, "error");
            }
        } catch (error) {
            showAlert("Error al conectar con el servidor", "error");
        }
    };
    
    return (
        <div className="register-container">
            <div className="left-section">
                <img src="/images/logo.png" alt="Logo Teach Track" />
            </div>

            <div className="right-section">
                <form onSubmit={handleRegister} className="register-form">
                    <h2>Registro</h2>

                    <div className="input-container">
                        <label>Nombre(s):</label>
                        <Input placeholder="Ingresa tu(s) nombre(s)" name="nombre" type="text" value={formData.nombre} onChange={handleChange} />
                        {errors.nombre && <p className="error-message">{errors.nombre}</p>}
                    </div>

                    <div className="input-container">
                        <label>Apellido Paterno:</label>
                        <Input placeholder="Ingresa tu apellido paterno" name="apellidoP" type="text" value={formData.apellidoP} onChange={handleChange} />
                        {errors.apellidoP && <p className="error-message">{errors.apellidoP}</p>}
                    </div>

                    <div className="input-container">
                        <label>Apellido Materno:</label>
                        <Input placeholder="Ingresa tu apellido materno" name="apellidoM" type="text" value={formData.apellidoM} onChange={handleChange} />
                        {errors.apellidoM && <p className="error-message">{errors.apellidoM}</p>}
                    </div>

                    <div className="input-container">
                        <label>Correo:</label>
                        <Input placeholder="Ingresa tu correo" name="correo" type="email" value={formData.correo} onChange={handleChange} />
                        {errors.correo && <p className="error-message">{errors.correo}</p>}
                    </div>

                    <div className="input-container">
                        <label>Contraseña:</label>
                        <div className="password-container">
                            <Input 
                                placeholder="Ingresa tu contraseña" 
                                name="contraseña" 
                                type={showPassword ? "text" : "password"}
                                value={formData.contraseña} 
                                onChange={handleChange} 
                            />
                            <span onClick={togglePasswordVisibility} className="toggle-password">
                                <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} icon`}></i>
                            </span>
                        </div>
                        {errors.contraseña && <p className="error-message">{errors.contraseña}</p>}
                    </div>

                    <div className="input-container">
                        <label>Confirmar Contraseña:</label>
                        <div className="password-container">
                            <Input 
                                placeholder="Confirma tu contraseña" 
                                name="confirmarContraseña" 
                                type={showConfirmPassword ? "text" : "password"} // Usar el nuevo estado
                                value={formData.confirmarContraseña} 
                                onChange={handleChange} 
                            />
                            <span onClick={toggleConfirmPasswordVisibility} className="toggle-password">
                                <i className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} icon`}></i> {/* Usar el nuevo estado */}
                            </span>
                        </div>
                        {errors.confirmarContraseña && <p className="error-message">{errors.confirmarContraseña}</p>}
                    </div>

                    <button type="submit" className="register-button">Registrarse</button>

                    {/* Enlace para regresar al login */}
                    <p className="switch-form">
                        ¿Ya tienes cuenta? <span onClick={() => handleNavigateToLogin()} style={{ cursor: "pointer", color: "#00bf63", textDecoration: "underline" }}>Inicia sesión aquí</span>
                    </p>
                </form>
            </div>
        </div>
    );
}

export default Register;